module.exports = __webpack_public_path__ + "091ce6caa3da125e7015e107c4d1c52e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/camp1.jpeg
// module id = 1134
// module chunks = 0